import { render, staticRenderFns } from "./CloudInfor.vue?vue&type=template&id=c327f046&"
import script from "./CloudInfor.vue?vue&type=script&lang=js&"
export * from "./CloudInfor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports